export const VER_MetaInfoWibMessageContent = 1

export interface IMetaInfoWibMessageContent {
    message: string
    version: number
}